import { getCurrentInstance } from 'vue';

// Provides access to the headful setter from a setup function
// in the composition API.
export function useHeadfulSetter() {
  return getCurrentInstance().proxy.$headful;
}
